export type Offer3dStageLink = {stageId: number; link?: string};
export type Offer3dViewEntry = {id: number; link: string; stageLinks?: Offer3dStageLink[]; history?: {link: string; stageLinks?: Offer3dStageLink[]}[]};

export const OFFER_3D_VIEWS: Offer3dViewEntry[] = [
    //Warszawa
    {id: 16394, link: "https://poly.cam/capture/ec048c97-b5c0-42ae-ac14-14c0633c0b1c"},
    {id: 19726, link: "https://poly.cam/capture/5006fc09-dadf-47a6-ae5d-95cdaa281eee"},
    {id: 19221, link: "https://poly.cam/capture/d37b1f34-ca0b-4716-9537-d98e1c383ecb"},
    {id: 18722, link: "https://poly.cam/capture/7f5bcc0f-a19d-4c5d-9319-4177a335d611"},
    {id: 19712, link: "https://poly.cam/capture/4922c6b6-eee9-485b-9aa3-4e3d7e5cb148"},
    {id: 19578, link: "https://poly.cam/capture/e54f73f6-b4a2-476f-a312-bca4f5fa46d3"},
    {id: 19339, link: "https://poly.cam/capture/5efba23f-6126-4dbc-b02e-c5731f8a8551"},
    {id: 19367, link: "https://poly.cam/capture/e1062728-309e-45b5-ac65-4e87df25be4f"},
    {
        id: 15112,
        link: "https://poly.cam/capture/8e9f9112-3e6e-4002-af71-e1c60612aceb",
        stageLinks: [
            {stageId: 1335, link: "https://poly.cam/capture/80b94680-e476-4072-a088-861a05ef7388"},
            {stageId: 847, link: "https://poly.cam/capture/5b9f9fed-2ac6-4351-9c36-1ff159c60400"}
        ]
    },
    {id: 18907, link: "https://poly.cam/capture/22b96086-7b3f-4ee5-a2a0-bfece7ce0945"},
    {id: 19038, link: "https://poly.cam/capture/b696fbd1-9332-47b7-9295-fac99632f54e"},
    {id: 19439, link: "https://poly.cam/capture/dcede0de-3439-4b71-9480-ff1db65f490c"},
    {id: 19345, link: "https://poly.cam/capture/b5077555-19da-404b-9bf7-a558ab1e892f"},
    {
        id: 19338,
        link: "https://poly.cam/capture/c64166cd-5055-49c1-af3c-9ce9c484c573",
        history: [{link: "https://poly.cam/capture/52b4c37b-ac0b-48a8-b9cc-0e314e5f8031"}]
    },
    {id: 14574, link: "https://poly.cam/capture/f2a0e819-ad01-42c8-a217-e5c1f5b1cc74"},
    {
        id: 16644,
        link: "https://poly.cam/capture/b498d752-a42c-4ab4-b626-4fddb3f005e9",
        history: [{link: "https://poly.cam/capture/1bead3ad-b57a-42bb-9a98-1d55b5764620"}]
    },
    {id: 17660, link: "https://poly.cam/capture/93f98dd4-3df3-4297-b7f7-f224ca38b328"},
    {id: 18750, link: "https://poly.cam/capture/c1212089-95c8-484a-ad13-c46043ace6e6"},
    {
        id: 18076,
        link: "https://poly.cam/capture/20251fee-1e68-4267-9f9f-0e2cbf9df225",
        history: [{link: "https://poly.cam/capture/444c55ee-a944-4a42-bc64-1d44a17c8c5e"}]
    },
    {id: 17915, link: "https://poly.cam/capture/7a56be6c-8603-4050-9bc1-52ccf1d84b78"},
    {
        id: 13935,
        link: "https://poly.cam/capture/63594d35-caff-4385-b07e-6448b9a00581",
        history: [{link: "https://poly.cam/capture/6f1af6cf-f34e-4e1f-96b0-4524c4857733"}]
    },
    {
        id: 16714,
        link: "https://poly.cam/capture/82d14567-2b11-4636-a5bf-8ac5cc462d6b",
        history: [{link: "https://poly.cam/capture/9a14fef6-c08f-43ee-87f1-171081036cca"}]
    },
    {id: 16507, link: "https://poly.cam/capture/0ec144a2-8c39-422f-b336-b31976bcb40b"},
    {id: 19645, link: "https://poly.cam/capture/b7cbf8ee-1171-45f7-8757-a470e3bb669a"},
    {id: 19541, link: "https://poly.cam/capture/a85170b1-c96f-4bec-84df-1670580a9028"},
    {id: 19441, link: "https://poly.cam/capture/2d9776ef-5c15-4aaa-8d03-6e2142968e9d"},
    {id: 19365, link: "https://poly.cam/capture/43a171f9-d5f8-43d5-a329-c656674f5eab"},
    {id: 19722, link: "https://poly.cam/capture/771aba2e-5c73-40cd-926c-a1c8d1615ffa"},
    {id: 18877, link: "https://poly.cam/capture/144ff29f-f1c7-44e2-8920-86ef9908c931"},
    {id: 19690, link: "https://poly.cam/capture/f01541c4-c0ab-49bf-9387-2d821195379f"},
    {id: 15791, link: "https://poly.cam/capture/9e35722f-ce9a-462d-959e-cb72f40fef05"},
    {id: 19394, link: "https://poly.cam/capture/7056cfe6-6569-47f3-95b4-65e1d3c3ae47"},
    {id: 19627, link: "https://poly.cam/capture/0e674c92-96d0-4206-b59a-5ec4789e9908"},
    {id: 18284, link: "https://poly.cam/capture/71723a68-db92-4762-9f07-49da9869e363"},
    {id: 17782, link: "https://poly.cam/capture/b420b279-5560-484f-b1ba-f6648e9037e3"},
    {id: 14737, link: "https://poly.cam/capture/577791a6-2f82-48b5-a0ec-fdcde4df6767"},
    {id: 19379, link: "https://poly.cam/capture/cde01f8f-9a9f-48df-b7c1-ab81275b7e89"},
    {
        id: 17823,
        link: "https://poly.cam/capture/7bf1ecb0-ccdb-4209-81e7-2c8e6b63a031",
        history: [{link: "https://poly.cam/capture/103be45e-c9c4-4561-acfa-461f159a72aa"}]
    },
    {id: 19622, link: "https://poly.cam/capture/7b4a2254-f1bf-4e78-8fa6-2a336ac7b526"},
    {id: 17539, link: "https://poly.cam/capture/d820d570-98d7-4c98-9449-a79b80474889"},
    {id: 16654, link: "https://poly.cam/capture/6f8892b2-9943-4d26-ade6-7fbc4264b7a1"},
    {id: 19009, link: "https://poly.cam/capture/d23f0f91-850a-450e-9ddc-b4c47f55b1e4"},
    {id: 17405, link: "https://poly.cam/capture/503cc324-57a5-449e-87cd-1857bea49810"},
    {id: 16436, link: "https://poly.cam/capture/ebed1444-a68a-4a97-8eca-c85b2e1c0935"},
    {id: 19325, link: "https://poly.cam/capture/9c92a02b-452d-402e-bb51-acd58b9f812a"},
    {id: 18383, link: "https://poly.cam/capture/3ffda269-f1b1-4fc1-b809-de16f05a9162"},
    {id: 17209, link: "https://poly.cam/capture/3a1f6f26-c349-4237-8b95-c09dab1b54d3"},
    {id: 19428, link: "https://poly.cam/capture/cff4f5d7-d34a-4358-a8b9-f6c39059749a"},
    {id: 19081, link: "https://poly.cam/capture/448dd4d4-411a-47db-98ae-e853fdf9b908"},
    {id: 19227, link: "https://poly.cam/capture/9441a62c-875f-4703-aac7-b456ac6e41e6"},
    {id: 18855, link: "https://poly.cam/capture/ccf6263c-db7f-47b1-939e-19643f5a4e48"},
    {
        id: 17980,
        link: "https://poly.cam/capture/6d89171e-0dfa-4029-a29c-db7a4d2cddd9",
        history: [{link: "https://poly.cam/capture/2b790101-676a-4f43-99d9-455a1c6fb81b"}]
    },
    {id: 13981, link: "https://poly.cam/capture/43a171f9-d5f8-43d5-a329-c656674f5eab"},
    {id: 18850, link: "https://poly.cam/capture/8dbe856e-8a49-40aa-a31c-db05427a42b9"},
    {id: 17225, link: "https://poly.cam/capture/144ff29f-f1c7-44e2-8920-86ef9908c931"},
    {id: 14742, link: "https://poly.cam/capture/0e674c92-96d0-4206-b59a-5ec4789e9908"},
    {id: 18815, link: "https://poly.cam/capture/5ab2c833-fdbd-45fe-b6fa-2718e511ba15"},
    {id: 18472, link: "https://poly.cam/capture/0260e255-4a26-4ca1-bfff-3cd50c86cdf7"},
    {id: 14503, link: "https://poly.cam/capture/840720a0-b162-4fe0-950d-6ec7f717cf6a"},
    {id: 17869, link: "https://poly.cam/capture/e725751e-707a-42a0-9e69-2afcf99b667d"},
    {id: 18392, link: "https://poly.cam/capture/b6806071-d39e-4f88-96c9-f13f1cb96872"},
    {id: 19184, link: "https://poly.cam/capture/f1447926-eb9d-413c-8ecb-c6e2e5daeb82"},
    {id: 19943, link: "https://poly.cam/capture/a32ad1f6-6850-4f3d-96e5-63dee2771f7a"},
    {id: 17434, link: "https://poly.cam/capture/85565a66-99f0-42e6-a4d5-4b450b24f2ef"},
    {id: 9673, link: "https://poly.cam/capture/5fd82ae5-c413-43d7-9f62-403055ad4a11"},
    {id: 18757, link: "https://poly.cam/capture/2735653c-4d69-487e-958d-e309505f5a98"},
    {id: 17706, link: "https://poly.cam/capture/29e7cb0c-d061-4742-8b16-5826c879ae28"},
    {id: 17635, link: "https://poly.cam/capture/5853a0bc-cd60-4d0c-bb6c-b010ecf5da89"},
    {id: 4697, link: "https://poly.cam/capture/89beee2d-da6a-4f21-ae13-459f6eadae56"},
    {id: 16951, link: "https://poly.cam/capture/a8271eca-ffee-4588-8e93-133ebfea8de8"},
    {id: 19400, link: "https://poly.cam/capture/b523e435-ee03-4929-b22b-26a81a1d612d"},
    {id: 19288, link: "https://poly.cam/capture/9221240f-4660-4774-9197-6b833f384228"},
    {id: 18759, link: "https://poly.cam/capture/bc4d63f7-d829-4b81-b56c-2f08ebb4d7dc"},
    {id: 17800, link: "https://poly.cam/capture/2e662573-a750-4341-b4fb-0a0cb0e61250"},
    {id: 17998, link: "https://poly.cam/capture/10af6221-f286-4a56-aa95-7b65968a4f97"},
    {id: 16577, link: "https://poly.cam/capture/16413cb7-d7b0-4548-a562-5273981d69b4"},
    {id: 18951, link: "https://poly.cam/capture/939d2514-e0f8-4ea0-bbe5-70b8dcb9bbb6"},
    {id: 19588, link: "https://poly.cam/capture/dfa12c76-8604-44bb-b1f9-830487a9bba8"},
    {id: 10710, link: "https://poly.cam/capture/19ec05b3-5566-4f0a-8009-f573bcf91582"},
    {id: 17596, link: "https://poly.cam/capture/64d388fc-aa46-401b-ad39-99fa24c50cac"},
    {id: 7673, link: "https://poly.cam/capture/a1ce7f10-b3fa-401f-9f1a-389e2068f3e2"},
    {id: 17784, link: "https://poly.cam/capture/26243380-8f3b-49b7-a6b6-9200a371f9b8"},
    {id: 16406, link: "https://poly.cam/capture/8019598e-90af-43b2-8451-b4e465febc46"},
    {id: 19494, link: "https://poly.cam/capture/51864b0c-bbf9-4fb9-8514-946f8d5f22c2"},
    {id: 13391, link: "https://poly.cam/capture/5dda3124-8582-4813-95ce-22a8cc8d94fe"},
    {id: 19266, link: "https://poly.cam/capture/573872bc-7b40-4816-8c63-542609a5030c"},
    {id: 16642, link: "https://poly.cam/capture/7342ed69-596a-414b-bbb9-710cced32b1e"},
    {
        id: 11695,
        link: "https://poly.cam/capture/5d178ce7-1abd-4b88-a58f-db363fa26628",
        stageLinks: [{stageId: 1098, link: "https://poly.cam/capture/84cc6ec3-26bd-48f3-bebb-2cda2cbfcf5f"}],
        history: [{link: "https://poly.cam/capture/84cc6ec3-26bd-48f3-bebb-2cda2cbfcf5f"}]
    },
    {id: 19440, link: "https://poly.cam/capture/8d017e2b-b87c-4f65-bb8f-6d0413640510"},
    {id: 17443, link: "https://poly.cam/capture/60a47f9f-cee6-4649-b5e5-04a913cf04ac"},
    {id: 18906, link: "https://poly.cam/capture/6c618856-0402-4139-b1f7-54fecb6e4e35"},
    {id: 10364, link: "https://poly.cam/capture/900a8136-0f07-45a8-ace1-af3058cebf1b"},
    {id: 17910, link: "https://poly.cam/capture/07409bf3-5b71-4332-be5c-5446cd84739a"},
    {id: 19397, link: "https://poly.cam/capture/c14e0e56-7d06-4dd2-b6be-bba9ad82b1a5"},
    {id: 19705, link: "https://poly.cam/capture/b053a517-fbcc-4499-a197-464cc4f24e0e"},
    {id: 16202, link: "https://poly.cam/capture/c053ce75-dd92-4823-82b5-70810bc824a8"},
    {id: 20094, link: "https://poly.cam/capture/c5285906-6bbe-4a6f-86d7-54aeb82b12bb"},
    {id: 17090, link: "https://poly.cam/capture/3dd78789-27e8-432a-a01c-edf9fa820b3c"},
    {id: 20011, link: "https://poly.cam/capture/1f9ba517-ab58-4696-9034-0cee8d0f58d3"},
    {id: 19751, link: "https://poly.cam/capture/b5e7e9fa-f6a7-49a1-9485-21af79f84ab3"},
    {id: 17901, link: "https://poly.cam/capture/186a3684-42cc-499a-937c-e7eec952cded"},
    {id: 18048, link: "https://poly.cam/capture/16a52cde-02ad-49e7-80c7-2b6c41c21463"},
    {id: 18508, link: "https://poly.cam/capture/27720850-3580-4772-ba00-4c6a14d430f5"},
    {id: 18341, link: "https://poly.cam/capture/fd5f9357-81cd-4bbc-9b93-4dad60c2c170"},
    {id: 17814, link: "https://poly.cam/capture/fab53046-3197-4143-8d7b-acb1fd9faace"},
    {id: 17764, link: "https://poly.cam/capture/ebd5b0e2-0543-47e8-af0d-7d6257accd9f"},
    {id: 16798, link: "https://poly.cam/capture/5a503278-4878-462b-a3be-17c8502353e5"},
    {id: 19501, link: "https://poly.cam/capture/f0532ce6-87a4-4b1e-8c33-ee241d6c6e98"},
    {id: 19250, link: "https://poly.cam/capture/cd31b0c3-af42-4ce7-84e8-6623c3a74f8c"},
    {id: 19183, link: "https://poly.cam/capture/3850dbc0-f67d-40b5-812a-ea751f1f83a7"},
    {id: 19095, link: "https://poly.cam/capture/9f8b5ef6-b4f0-4bc6-b23e-5576e3ff2646"},
    {id: 17714, link: "https://poly.cam/capture/020bc00e-275e-4ddb-be1c-d30cd452e606"},
    {id: 14816, link: "https://poly.cam/capture/c3b2e7a1-9089-45f1-88a7-26ea35eef376"},
    {id: 17685, link: "https://poly.cam/capture/31f464e8-db85-4269-b508-a88e3e90fbde"},
    {id: 16655, link: "https://poly.cam/capture/79d8557a-4ad9-44d5-9891-5f1d3dabc6ef"},
    {id: 18123, link: "https://poly.cam/capture/020b9cbf-9ad3-484c-ba0a-a1722be48273"},
    {id: 20163, link: "https://poly.cam/capture/8abf2a19-1452-49ef-aeb5-a9586038f8fc"},
    {id: 17196, link: "https://poly.cam/capture/aa740ad5-57d2-451c-95d6-54756afa2365"},
    {id: 16774, link: "https://poly.cam/capture/6648a4c2-783c-4865-85aa-d2030c613a81"},
    {id: 16207, link: "https://poly.cam/capture/f3b33777-41cc-4d18-a932-fa680c455b2b"},
    {id: 17305, link: "https://poly.cam/capture/0cf84c70-2fc8-44e1-be44-6019c450c394"},
    {id: 18621, link: "https://poly.cam/capture/5fe4faff-dcf7-4ce5-ad39-98b6f5ff3d86"},
    {id: 10122, link: "https://poly.cam/capture/73d7b498-c9f6-48bb-9ed3-e029d296329b"},
    {id: 18514, link: "https://poly.cam/capture/250efc4a-3cb2-4460-a437-2d4472afda4e"},
    {id: 17239, link: "https://poly.cam/capture/a08d421e-6e51-41a6-8e13-448617171c6b"},
    {id: 13729, link: "https://poly.cam/capture/7d7366dd-2312-4206-ac20-2d1f0fe23901"},
    {id: 20258, link: "https://poly.cam/capture/8b1b79fa-88bf-4b7d-afdb-9f4b5235ae8b"},
    {id: 13879, link: "https://poly.cam/capture/7a9da8e4-d6fe-4365-a3eb-3b393ac33369"},
    {id: 16760, link: "https://poly.cam/capture/2f55fbf5-9635-4287-8828-c439a636b475"},
    {id: 16755, link: "https://poly.cam/capture/128bddbc-d82e-425a-b2ac-22b4a2b04c51"},
    {id: 17320, link: "https://poly.cam/capture/d919a1c7-7edb-4516-9d4e-e96477404a1b"},
    {id: 16226, link: "https://poly.cam/capture/0f27f78d-3cf8-46c2-a8d4-1080cd42b04e"},
    // Kraków
    {
        id: 15916,
        link: "https://poly.cam/capture/a55eab86-c84d-4b35-ab38-1bd0da8e4d18",
        history: [{link: "https://poly.cam/capture/ba183d67-c389-496e-b4e8-e053dd0267c4"}]
    },
    {
        id: 17751,
        link: "https://poly.cam/capture/909ecb0e-9707-4daa-b5f4-e5a85d47af0c",
        history: [{link: "https://poly.cam/capture/5dd38ae5-b343-4b58-8e77-717997eac3a2"}]
    },
    {
        id: 17776,
        link: "https://poly.cam/capture/fcc58636-85bc-436e-b079-7c6b73a30ae0",
        history: [{link: "https://poly.cam/capture/9a8b1f6d-9e66-4659-a928-daf327a2814c"}]
    },
    {
        id: 17878,
        link: "https://poly.cam/capture/7bd32628-3099-4e86-a014-2c788a48a4b8",
        history: [{link: "https://poly.cam/capture/709bf5fb-52db-4552-a6bc-d9f3d218c128"}]
    },
    {
        id: 19549,
        link: "https://poly.cam/capture/9b656bca-1f01-4d62-bb97-bb00ccf5d865",
        history: [{link: "https://poly.cam/capture/506fc0c0-137a-4fd0-8cd3-d8fe45cee8e3"}]
    },
    {id: 19047, link: "https://poly.cam/capture/49da0243-d81d-42cc-a06f-26ec8db0e040"},
    {
        id: 16983,
        link: "https://poly.cam/capture/55cc6b1d-b02c-4bb4-a4a2-09abf2e6d8aa",
        history: [{link: "https://poly.cam/capture/7a699982-e85a-43cc-bcd6-050207158b28"}]
    },
    {
        id: 16851,
        link: "https://poly.cam/capture/3e8e3ac2-a9f5-4d52-984f-8cea20f1d1aa",
        history: [{link: "https://poly.cam/capture/a749a2de-3a13-48ca-9c3f-0720d3e80317"}]
    },
    {
        id: 18385,
        link: "https://poly.cam/capture/88b952d8-4b69-40b2-b571-4c3b1d4c6d9a",
        history: [{link: "https://poly.cam/capture/cc10f81e-4076-449d-9acc-5454f5e4be2a"}]
    },
    {
        id: 17289,
        link: "https://poly.cam/capture/0f0a9bc0-afe7-4740-b755-02115dfdbf61",
        history: [{link: "https://poly.cam/capture/faba676c-6454-4e48-b3a3-26e1cfcea25e"}]
    },
    {id: 18283, link: "https://poly.cam/capture/a27cbd0d-feb3-4bff-84fd-bf9539630877"},
    {id: 17493, link: "https://poly.cam/capture/c39adcff-98f5-4063-a47d-3a3457652ff0"},
    {id: 15462, link: "https://poly.cam/capture/aaa50b50-09de-4722-8b6c-18ce8089a2bc"},
    {id: 19045, link: "https://poly.cam/capture/9cc1ada3-8ae9-4cab-8168-722a704ea7e0"},
    {id: 17812, link: "https://poly.cam/capture/c227801f-3b40-437b-aff1-109124213593"},
    {id: 19800, link: "https://poly.cam/capture/7874253a-be6d-47b5-8d4d-1ca815107e7f"},
    {id: 17601, link: "https://poly.cam/capture/347ebf18-61a3-4d5a-93a8-ce6d4a6b4492"},
    {id: 18706, link: "https://poly.cam/capture/2a6ad0f3-233d-438e-9696-e8189a9e22f8"},
    {id: 17309, link: "https://poly.cam/capture/ede381c0-a4ab-4dcb-8923-ad2281eda93a"},
    {id: 12831, link: "https://poly.cam/capture/8a30ecff-e2c0-4527-91be-c46e36a7afbc"},
    {id: 18242, link: "https://poly.cam/capture/2ba25dcd-63d8-4e35-96da-30645eab0156"},
    {id: 17526, link: "https://poly.cam/capture/894766cd-ee49-4b47-9df3-d6cf7036c779"},
    {id: 17367, link: "https://poly.cam/capture/af239131-e103-44e9-bde3-a5899c0535e5"},
    {id: 20204, link: "https://poly.cam/capture/1f5e6865-5c21-4a00-beba-24f3478d8778"},
    {id: 16036, link: "https://poly.cam/capture/4484484c-deb9-4eee-9dfc-a30829ae2323"},
    {id: 14423, link: "https://poly.cam/capture/a57fc610-61df-4639-836a-50764916fa72"},
    {id: 19652, link: "https://poly.cam/capture/203d6582-ba54-4747-b0d6-cb73f6cbe942"},
    {id: 18831, link: "https://poly.cam/capture/a8d15b8a-7b8c-4ed2-a4d7-0d0d759f2763"},
    {id: 17541, link: "https://poly.cam/capture/356cb65f-c6af-4d54-b986-c7c260cac1d4"},
    {id: 14404, link: "https://poly.cam/capture/d6fec8a6-3bd1-4a69-bb45-2eec4ce0bd40"},
    {id: 17463, link: "https://poly.cam/capture/83e70faa-5224-4c94-bdf5-f0f2751a4cca"},
    {id: 19247, link: "https://poly.cam/capture/3b0c47bd-6311-4378-bcc8-8f66b1a04186"},
    {id: 17527, link: "https://poly.cam/capture/b63b7112-06b0-400c-91f7-24346f233171"},
    {id: 18821, link: "https://poly.cam/capture/95fbe5c7-a548-4bce-86f9-0f794bc70c8a"},
    {id: 15016, link: "https://poly.cam/capture/7af23b5f-1943-4ed7-b435-78721f3c7e05"},
    {id: 19540, link: "https://poly.cam/capture/eb06b062-fc73-4f9b-b9d0-f96512af711d"},
    {id: 20121, link: "https://poly.cam/capture/359ff5cc-50ca-4c45-af59-ad963f592195"},
    {id: 18742, link: "https://poly.cam/capture/bc137ca3-c7d0-4beb-b537-a6f2478eecf7"},
    {id: 19460, link: "https://poly.cam/capture/5f94a0c7-5241-472a-8cb3-9c2ade4287ff"},
    {id: 7849, link: "https://poly.cam/capture/dac57b95-0e48-40c9-a4c5-218adfaeb7d0"},
    {id: 16435, link: "https://poly.cam/capture/bfa71b09-820e-4a4e-af01-75c2c235a154"},
    {id: 19744, link: "https://poly.cam/capture/20b9a59a-1fc9-42f6-b911-82ec2d5210b3"},
    {id: 19922, link: "https://poly.cam/capture/1381624c-9f26-45cb-9855-53333e36580f"},
    {id: 19659, link: "https://poly.cam/capture/ea8dd122-7434-4a32-a121-7e93999ddb21"},
    {id: 15411, link: "https://poly.cam/capture/cd749860-02e6-4fd7-9c57-c4b988fd6b5e"},
    {id: 13081, link: "https://poly.cam/capture/0e4187a7-171f-4049-9fb2-70297a4be55e"},
    {id: 840, link: "https://poly.cam/capture/61c19e61-e592-4d60-84d1-1e33d34d1448"},
    {id: 17074, link: "https://poly.cam/capture/b631d21b-ee6a-4b96-bcde-c8355b91b3f1"},
    {id: 18882, link: "https://poly.cam/capture/56699c6d-e97c-4277-95b2-a6fd80176120"},
    {id: 16361, link: "https://poly.cam/capture/f53b56bd-6b5e-408f-8449-49acdf1e5b49"},
    {id: 18254, link: "https://poly.cam/capture/6bb4628a-ac37-4ba4-8bf9-cfc293745229"},
    {id: 19634, link: "https://poly.cam/capture/9e3c4d82-fe3f-4402-aa77-29221064cbca"},
    {id: 18957, link: "https://poly.cam/capture/6c34e502-1541-4d82-a199-6539972d6b0c"},
    {id: 18230, link: "https://poly.cam/capture/a7f08f86-4edc-456c-9e21-1d20004c0f1a"},
    {id: 19878, link: "https://poly.cam/capture/074c8f0c-cf3f-4381-9544-f7041b4e2ca2"},
    {id: 18286, link: "https://poly.cam/capture/0d8b2cc9-40e7-494a-88ce-142a8e44d420"},
    {id: 16274, link: "https://poly.cam/capture/6a2208b9-ba9e-4219-946a-f8fbc3af6c00"},
    {id: 16950, link: "https://poly.cam/capture/c4925609-43d9-4bff-a8c4-ea0dc822a2ef"},
    {id: 17498, link: "https://poly.cam/capture/b68d7639-671f-45fb-a36c-a7614da6dc44"},
    {id: 18496, link: "https://poly.cam/capture/3f6c0ab1-ec27-4bd1-9e7d-5c3849246ee0"},
    // Poznań
    {id: 18826, link: "https://poly.cam/capture/58c42f89-44d3-4343-98fb-4f1e0dc4dd1c"},
    {id: 16944, link: "https://poly.cam/capture/11baa27b-8662-4616-8be1-c77dfa3d6b07"},
    {id: 16937, link: "https://poly.cam/capture/a6bc6204-e39d-43a1-9104-2b28a5157c9e"},
    {id: 19463, link: "https://poly.cam/capture/fbfaf9ba-a5d0-4d3b-bfed-75e84da1f21c"},
    {id: 18497, link: "https://poly.cam/capture/cedc2a02-5f0b-4eaa-93d1-02c994f113d4"},
    {id: 19010, link: "https://poly.cam/capture/b48dedfb-8249-41b9-a923-a806f79298f1"},
    {id: 17247, link: "https://poly.cam/capture/d41ebd34-3261-407b-90a2-62ffe60ae9b1"},
    {id: 15914, link: "https://poly.cam/capture/b9689bd6-39fa-4b80-a084-ccf6909a7c2c"},
    {id: 10708, link: "https://poly.cam/capture/d8ecf900-5f7d-44e1-b4de-3637df568c07"},
    {
        id: 15148,
        link: "https://poly.cam/capture/6d186bc3-179b-4e74-ae19-3c666d082e84",
        stageLinks: [{stageId: 802, link: "https://poly.cam/capture/0c5005bd-c104-403f-9605-5718fbaad6ed"}]
    },
    {id: 16809, link: "https://poly.cam/capture/6142af90-bb41-4fab-a851-b3c6a552f3e8"},
    {id: 16228, link: "https://poly.cam/capture/9f9118ea-88b8-4914-aade-b59bbf5d70f0"},
    {id: 18139, link: "https://poly.cam/capture/95710ef9-9462-46f9-bbb9-f47210bc4744"},
    {id: 17044, link: "https://poly.cam/capture/1bcb47e6-8a15-4d71-91d1-4916b7fdeff8"},
    {id: 17921, link: "https://poly.cam/capture/38171199-a8af-459c-98c9-02407084a135"},
    {id: 19459, link: "https://poly.cam/capture/f26958d2-e85f-4eec-b860-1f433f57d16c"},
    {id: 14159, link: "https://poly.cam/capture/1c71506e-148b-4762-b5e9-3e272346c898"},
    {id: 19561, link: "https://poly.cam/capture/a45b381f-9b80-45f4-b5d8-f4f5843a825e"},
    {id: 17078, link: "https://poly.cam/capture/14e9bd83-5cfd-4282-b119-fbfdabcfa96d"},
    {id: 12991, link: "https://poly.cam/capture/5c947d52-9610-4d16-8b0b-b270f9a2afe1"},
    {id: 18833, link: "https://poly.cam/capture/ba0f0bc3-f8f1-4521-90df-0caefd50b62c"},
    {id: 14425, link: "https://poly.cam/capture/556e1a28-7ea3-485a-acfb-a7e2128697ee"},
    {id: 4930, link: "https://poly.cam/capture/66cf8255-adc5-465e-84a0-080a58aedfe8"},
    {id: 17474, link: "https://poly.cam/capture/4a344fa7-7c74-42e8-94b8-083e48fd8837"},
    {id: 16668, link: "https://poly.cam/capture/26301cc2-2769-4ac1-837c-65ec57eba891"},
    {id: 19058, link: "https://poly.cam/capture/8e566464-9333-4ad2-8352-ff768d1a4e6d"},
    {id: 17845, link: "https://poly.cam/capture/f99ab6ab-643e-4bd1-b158-0c5f9df08434"},
    {id: 16365, link: "https://poly.cam/capture/8b6a3679-a0e7-4d21-9341-469759c76b68"},
    {id: 18256, link: "https://poly.cam/capture/bef78bf4-a10e-4183-901f-616eabcd439b"},
    {id: 16294, link: "https://poly.cam/capture/29be0ea4-e30f-4068-bb4a-d1b469cbd93a"},
    {id: 17065, link: "https://poly.cam/capture/bf97de04-ffb3-42b2-8097-560450dd8289"},
    {id: 17672, link: "https://poly.cam/capture/610bb611-64be-44ee-b4ad-4f051c964eab"},
    {id: 14111, link: "https://poly.cam/capture/96eaf2e5-f847-4612-9456-fc7abe82f50b"},
    {id: 17291, link: "https://poly.cam/capture/47c57fd7-bd68-4dc8-a3b6-dc6a1e515b25"},
    {id: 16538, link: "https://poly.cam/capture/ad97f90b-a90d-40e2-9c55-971a411271fc"},
    {id: 20059, link: "https://poly.cam/capture/e7b01111-edf6-4fbc-bad5-28e711302d1f"},
    {id: 15757, link: "https://poly.cam/capture/65fcef86-641c-4223-baae-54c1c224751c"},
    {id: 18998, link: "https://poly.cam/capture/5dd42cd3-2537-4501-ad2e-1b2ba4d311a8"},
    {id: 16194, link: "https://poly.cam/capture/5dd42cd3-2537-4501-ad2e-1b2ba4d311a8"},
    {id: 19140, link: "https://poly.cam/capture/e297deb8-bd6e-4743-a650-945ea7f6d65e"},
    {id: 16482, link: "https://poly.cam/capture/80cc7370-0d85-41d6-9667-99754d310669"},
    {id: 18105, link: "https://poly.cam/capture/a25ff40b-61d6-4032-a922-3733b602b436"},
    {id: 17794, link: "https://poly.cam/capture/6f26f687-01ae-4cb8-a623-2286f6d4ff67"},
    {id: 16548, link: "https://poly.cam/capture/b3f04d4e-c7b5-42f1-b188-292e6e2d7a59"},
    // Wrocław
    {id: 12266, link: "https://poly.cam/capture/ca66e111-0686-47ff-9b39-3c0a3d4af454"},
    {id: 17244, link: "https://poly.cam/capture/86363acf-d053-40a9-8d86-fb8040688ce4"},
    {id: 14657, link: "https://poly.cam/capture/3c6625e7-2cb2-4391-81ab-4b10e6b9be12"},
    {id: 19217, link: "https://poly.cam/capture/ba841fd1-c421-4653-b78a-df7948039d1a"},
    {id: 17908, link: "https://poly.cam/capture/7f5a3113-5350-478a-b859-d2924371d1fe"},
    {id: 19499, link: "https://poly.cam/capture/a5147257-91b2-4584-b9eb-cb21cce05010"},
    {id: 16304, link: "https://poly.cam/capture/a453560d-ace3-4cbd-ae78-9c9409918d2e"},
    {id: 19863, link: "https://poly.cam/capture/e3f1e41f-f9ab-4363-99b7-be6692b055ec"},
    {id: 19328, link: "https://poly.cam/capture/00d45414-65e1-4787-ad39-1213148bc13f"},
    {id: 18854, link: "https://poly.cam/capture/95accf83-f6d9-4ac9-a890-4ab1d349598c"},
    {id: 18958, link: "https://poly.cam/capture/6394128f-37bd-485f-bf76-056e417fca9d"},
    {id: 16029, link: "https://poly.cam/capture/3158388a-e9ff-44a7-b16f-b85f8ad0b77c"},
    {id: 15887, link: "https://poly.cam/capture/a51ff85c-df0d-4fb6-a140-324489135f30"},
    {id: 3947, link: "https://poly.cam/capture/60d5c3ec-eaa8-4d7b-8c4d-2fdaeef2ad62"},
    {id: 17655, link: "https://poly.cam/capture/07e918b8-7d6e-4a7b-8e8a-b8b6928b3227"},
    {id: 16695, link: "https://poly.cam/capture/601f2087-eb7a-46c3-81c4-c9d345d046f9"},
    {id: 18276, link: "https://poly.cam/capture/0349d7b9-719a-4993-aa61-3fd71b73f507"},
    {id: 16793, link: "https://poly.cam/capture/6584113b-d768-45b9-832c-0f26bb2c15d2"},
    {id: 16704, link: "https://poly.cam/capture/b4f14cb9-9a7b-4dc2-ab42-a5fc73fbd524"},
    {id: 17170, link: "https://poly.cam/capture/6fc864c2-6e4f-46aa-907f-393f3308fc92"},
    {id: 10296, link: "https://poly.cam/capture/6bb7543f-0c25-43da-ae6a-9f5d55ef59e8"},
    {id: 19845, link: "https://poly.cam/capture/209ddc24-66c2-4b2c-bfc5-5b91e76a7b8b"},
    {id: 17625, link: "https://poly.cam/capture/aebc6dc3-252f-4168-a79b-ab8ba0443b25"},
    {id: 16092, link: "https://poly.cam/capture/23383dc2-2452-4609-9540-fbd8ff94e793"},
    {id: 17168, link: "https://poly.cam/capture/448b713a-9db9-4098-9499-54936e2e3d01"},
    {id: 18956, link: "https://poly.cam/capture/34cd5b4a-63d7-4cac-861a-f7b27ee9dfea"},
    {id: 16972, link: "https://poly.cam/capture/4395d714-a81a-4d6f-820d-d83908583ece"},
    {id: 19973, link: "https://poly.cam/capture/b31a8a53-dc44-44ee-9fb3-60f36616ed7a"},
    {id: 14552, link: "https://poly.cam/capture/d0eb1f69-fc31-43dc-8823-4a2fa0d90d17"},
    {id: 19975, link: "https://poly.cam/capture/e871f047-3e89-420e-98f8-a0750ba6cefe"},
    {id: 15924, link: "https://poly.cam/capture/50c98510-2005-452a-8e1a-e4b74564d6c2"},
    {id: 19069, link: "https://poly.cam/capture/60c55634-1516-41e2-8a8f-85339fcf05e8"},
    {id: 12652, link: "https://poly.cam/capture/4ad434ef-30d9-47d7-bf36-00584ec8841a"},
    {id: 19644, link: "https://poly.cam/capture/d9d9491a-d4d1-4916-a4cc-8379fd0a3791"},
    {id: 19664, link: "https://poly.cam/capture/c3c75acb-957c-4b12-82ed-8b2cd5730af2"},
    {id: 16407, link: "https://poly.cam/capture/841dca1b-7651-4f29-89bd-f063219de9ef"},
    {id: 18345, link: "https://poly.cam/capture/c136034c-92be-4d6d-8daa-ea6227b8d244"},
    {id: 19002, link: "https://poly.cam/capture/38874799-f136-4aae-9e1a-d0738fad17aa"},
    {id: 17793, link: "https://poly.cam/capture/145770d9-5101-4cde-a2c1-7eeb66e4e852"},
    {id: 17752, link: "https://poly.cam/capture/f6a756e3-943c-4e80-899f-a453e83cbdb1"},
    {id: 16348, link: "https://poly.cam/capture/5a5e6a93-607f-4c6f-978e-8ab628336e31"},
    {id: 19044, link: "https://poly.cam/capture/167c264a-c677-443f-8b3c-81a7bb961d0e"},
    {id: 17123, link: "https://poly.cam/capture/56c12ea2-9db6-4fd1-ad14-4081541975a4"},
    {id: 15328, link: "https://poly.cam/capture/e478efeb-5776-4a78-9e79-14d78ff1b230"},
    {id: 19514, link: "https://poly.cam/capture/24f6cc21-f6bc-43a2-8f69-a795988c7652"},
    {id: 16681, link: "https://poly.cam/capture/866de97f-add1-444c-bc8b-0a374977f118"},
    {id: 15594, link: "https://poly.cam/capture/2b17c352-805e-47fd-91f0-5ffd49524c68"},
    //Trójmiasto
    {id: 19681, link: "https://poly.cam/capture/2b7a7faf-9889-4fe7-80e5-0f513dbdb026"},
    {id: 19646, link: "https://poly.cam/capture/e26c7a1d-76d5-4ad5-b82f-a92fb561be27"},
    {id: 19437, link: "https://poly.cam/capture/101fab69-b39d-440d-a02b-9b64f1bd3f1a"},
    {id: 17603, link: "https://poly.cam/capture/cb3a5b38-a69a-4391-8746-9cd1e29427ce"},
    {id: 14700, link: "https://poly.cam/capture/0205add9-83d0-4e33-a711-88a70a198d2e"},
    {id: 19156, link: "https://poly.cam/capture/e4a22a6c-1831-425a-82ef-ed4ee997aa37"},
    {id: 19143, link: "https://poly.cam/capture/3e188151-543c-4b32-85c0-d81e498e10b5"},
    {id: 9455, link: "https://poly.cam/capture/fbc7fec9-b786-4fce-9501-13159dca182e"},
    {id: 19020, link: "https://poly.cam/capture/45eea165-8b28-4023-abdf-6d8fb766e8a6"},
    {id: 18778, link: "https://poly.cam/capture/7c0f4de1-9b92-4f88-8133-9d53ef0c32dc"},
    {id: 18617, link: "https://poly.cam/capture/4a65b354-a6c6-451a-96e0-795fa957c531"},
    {id: 18289, link: "https://poly.cam/capture/9bf384c4-970c-4169-bd7a-8174e20645f6"},
    {id: 16686, link: "https://poly.cam/capture/264075a6-e04e-4718-96d1-10d0534aac7c"},
    {id: 18137, link: "https://poly.cam/capture/4731bc12-92c3-4406-a067-4ef739a68287"},
    {id: 14542, link: "https://poly.cam/capture/88915f24-17df-4743-8af6-bc533172c035"},
    {id: 18047, link: "https://poly.cam/capture/bdd72af5-e458-4dd6-bad4-8d38485977d7"},
    {id: 13149, link: "https://poly.cam/capture/ef3c7138-91df-4048-be37-f53c424e1438"},
    {id: 17826, link: "https://poly.cam/capture/c191b186-faa5-4e6b-9594-9d473eea3508"},
    {id: 17750, link: "https://poly.cam/capture/3cf94084-85be-40ca-b44f-6f1fbe27830d"},
    {id: 17675, link: "https://poly.cam/capture/5ece34f1-bf14-44c1-a8e0-d83669bcfc55"},
    {id: 17421, link: "https://poly.cam/capture/02f4fa62-d132-492e-803a-d045116fc691"},
    {id: 17213, link: "https://poly.cam/capture/889d4b21-e2fe-4fb8-b6f1-d86ae38bae00"},
    {id: 16575, link: "https://poly.cam/capture/a8f9a9f6-4fd9-421e-9728-8fcac0fb04f0"},
    {id: 16528, link: "https://poly.cam/capture/f372dda1-44eb-4840-b627-8465ca92fd14"},
    {id: 15816, link: "https://poly.cam/capture/cdfb6a0e-33cc-4079-94ed-692026a55482"},
    {id: 15379, link: "https://poly.cam/capture/1f5eb14f-071d-4dec-9242-dfff536a089f"},
    {id: 14738, link: "https://poly.cam/capture/9062ef3d-a8a5-4805-bb87-1c57919ccc8f"},
    {
        id: 15907,
        link: "https://poly.cam/capture/8395af90-4951-43f8-93b5-48f244443bb9",
        stageLinks: [{stageId: 1538, link: "https://poly.cam/capture/8a8104f9-ddae-487f-9175-18a63f3a2b96"}],
        history: [{link: "https://poly.cam/capture/8a8104f9-ddae-487f-9175-18a63f3a2b96"}]
    },
    {id: 19357, link: "https://poly.cam/capture/a402c7ac-a751-4415-923e-b0dca68798fe"},
    {id: 18796, link: "https://poly.cam/capture/8004ebc8-1bc3-4479-b7eb-cbc9e4dd7518"},
    {id: 16595, link: "https://poly.cam/capture/6f2e3a69-b876-4f75-bfd8-f06b75ebe39d"},
    {id: 15651, link: "https://poly.cam/capture/1dbe68d1-db95-4214-9197-3f695302bb37"},
    {id: 19608, link: "https://poly.cam/capture/7593cc48-8342-489f-a435-9e661a159925"},
    {id: 20055, link: "https://poly.cam/capture/a2db3177-9f1f-46da-9846-b7e228f44622"},
    {id: 14588, link: "https://poly.cam/capture/12bfcf52-5517-46d8-8513-fc03913f174b"},
    {id: 17678, link: "https://poly.cam/capture/0c0607ad-4387-450b-927a-2fedf4cb102f"},
    {id: 10409, link: "https://poly.cam/capture/d65c905a-0f62-4685-b321-f86e11536aa8"},
    {id: 15119, link: "https://poly.cam/capture/d58316fd-98f1-4126-8801-611745f686bf"},
    {id: 17824, link: "https://poly.cam/capture/c552661f-65db-4f04-8fd2-c45f7b259240"},
    {id: 18267, link: "https://poly.cam/capture/4a688908-f7ec-4213-b1e5-592de13bb161"},
    {id: 15180, link: "https://poly.cam/capture/49f79088-fa58-442c-b94c-909a1d28279d"},
    {id: 19187, link: "https://poly.cam/capture/4dfa0a70-3944-4d9d-a874-6aae5e356ba3"},
    {id: 16984, link: "https://poly.cam/capture/6db17809-95fe-4f83-85f4-698b131d8549"},
    {id: 20017, link: "https://poly.cam/capture/86217e8b-8151-48e6-813c-3070bce7714d"},
    {id: 19393, link: "https://poly.cam/capture/fc85ea0d-cf4c-4d58-91bc-45cecbc89fdb"},
    {id: 16949, link: "https://poly.cam/capture/0f0b881a-e985-42b6-b256-890d3959f625"}
];
export type Offer3dStageLink = {stageId: number; link?: string};
export type Offer3dViewEntry = {id: number; link: string; stageLinks?: Offer3dStageLink[]; history?: {link: string; stageLinks?: Offer3dStageLink[]}[]};

export const OFFER_3D_VIEWS: Offer3dViewEntry[] = [
    //Warszawa
    {id: 16394, link: "https://poly.cam/capture/ec048c97-b5c0-42ae-ac14-14c0633c0b1c"},
    {id: 19726, link: "https://poly.cam/capture/5006fc09-dadf-47a6-ae5d-95cdaa281eee"},
    {id: 19221, link: "https://poly.cam/capture/d37b1f34-ca0b-4716-9537-d98e1c383ecb"},
    {id: 18722, link: "https://poly.cam/capture/7f5bcc0f-a19d-4c5d-9319-4177a335d611"},
    {id: 19712, link: "https://poly.cam/capture/4922c6b6-eee9-485b-9aa3-4e3d7e5cb148"},
    {id: 19578, link: "https://poly.cam/capture/e54f73f6-b4a2-476f-a312-bca4f5fa46d3"},
    {id: 19339, link: "https://poly.cam/capture/5efba23f-6126-4dbc-b02e-c5731f8a8551"},
    {id: 19367, link: "https://poly.cam/capture/e1062728-309e-45b5-ac65-4e87df25be4f"},
    {
        id: 15112,
        link: "https://poly.cam/capture/8e9f9112-3e6e-4002-af71-e1c60612aceb",
        stageLinks: [
            {stageId: 1335, link: "https://poly.cam/capture/80b94680-e476-4072-a088-861a05ef7388"},
            {stageId: 847, link: "https://poly.cam/capture/5b9f9fed-2ac6-4351-9c36-1ff159c60400"}
        ]
    },
    {id: 18907, link: "https://poly.cam/capture/22b96086-7b3f-4ee5-a2a0-bfece7ce0945"},
    {id: 19038, link: "https://poly.cam/capture/b696fbd1-9332-47b7-9295-fac99632f54e"},
    {id: 19439, link: "https://poly.cam/capture/dcede0de-3439-4b71-9480-ff1db65f490c"},
    {id: 19345, link: "https://poly.cam/capture/b5077555-19da-404b-9bf7-a558ab1e892f"},
    {
        id: 19338,
        link: "https://poly.cam/capture/c64166cd-5055-49c1-af3c-9ce9c484c573",
        history: [{link: "https://poly.cam/capture/52b4c37b-ac0b-48a8-b9cc-0e314e5f8031"}]
    },
    {id: 14574, link: "https://poly.cam/capture/f2a0e819-ad01-42c8-a217-e5c1f5b1cc74"},
    {
        id: 16644,
        link: "https://poly.cam/capture/b498d752-a42c-4ab4-b626-4fddb3f005e9",
        history: [{link: "https://poly.cam/capture/1bead3ad-b57a-42bb-9a98-1d55b5764620"}]
    },
    {id: 17660, link: "https://poly.cam/capture/93f98dd4-3df3-4297-b7f7-f224ca38b328"},
    {id: 18750, link: "https://poly.cam/capture/c1212089-95c8-484a-ad13-c46043ace6e6"},
    {
        id: 18076,
        link: "https://poly.cam/capture/20251fee-1e68-4267-9f9f-0e2cbf9df225",
        history: [{link: "https://poly.cam/capture/444c55ee-a944-4a42-bc64-1d44a17c8c5e"}]
    },
    {id: 17915, link: "https://poly.cam/capture/7a56be6c-8603-4050-9bc1-52ccf1d84b78"},
    {
        id: 13935,
        link: "https://poly.cam/capture/63594d35-caff-4385-b07e-6448b9a00581",
        history: [{link: "https://poly.cam/capture/6f1af6cf-f34e-4e1f-96b0-4524c4857733"}]
    },
    {
        id: 16714,
        link: "https://poly.cam/capture/82d14567-2b11-4636-a5bf-8ac5cc462d6b",
        history: [{link: "https://poly.cam/capture/9a14fef6-c08f-43ee-87f1-171081036cca"}]
    },
    {id: 16507, link: "https://poly.cam/capture/0ec144a2-8c39-422f-b336-b31976bcb40b"},
    {id: 19645, link: "https://poly.cam/capture/b7cbf8ee-1171-45f7-8757-a470e3bb669a"},
    {id: 19541, link: "https://poly.cam/capture/a85170b1-c96f-4bec-84df-1670580a9028"},
    {id: 19441, link: "https://poly.cam/capture/2d9776ef-5c15-4aaa-8d03-6e2142968e9d"},
    {id: 19365, link: "https://poly.cam/capture/43a171f9-d5f8-43d5-a329-c656674f5eab"},
    {id: 19722, link: "https://poly.cam/capture/771aba2e-5c73-40cd-926c-a1c8d1615ffa"},
    {id: 18877, link: "https://poly.cam/capture/144ff29f-f1c7-44e2-8920-86ef9908c931"},
    {id: 19690, link: "https://poly.cam/capture/f01541c4-c0ab-49bf-9387-2d821195379f"},
    {id: 15791, link: "https://poly.cam/capture/9e35722f-ce9a-462d-959e-cb72f40fef05"},
    {id: 19394, link: "https://poly.cam/capture/7056cfe6-6569-47f3-95b4-65e1d3c3ae47"},
    {id: 19627, link: "https://poly.cam/capture/0e674c92-96d0-4206-b59a-5ec4789e9908"},
    {id: 18284, link: "https://poly.cam/capture/71723a68-db92-4762-9f07-49da9869e363"},
    {id: 17782, link: "https://poly.cam/capture/b420b279-5560-484f-b1ba-f6648e9037e3"},
    {id: 14737, link: "https://poly.cam/capture/577791a6-2f82-48b5-a0ec-fdcde4df6767"},
    {id: 19379, link: "https://poly.cam/capture/cde01f8f-9a9f-48df-b7c1-ab81275b7e89"},
    {
        id: 17823,
        link: "https://poly.cam/capture/7bf1ecb0-ccdb-4209-81e7-2c8e6b63a031",
        history: [{link: "https://poly.cam/capture/103be45e-c9c4-4561-acfa-461f159a72aa"}]
    },
    {id: 19622, link: "https://poly.cam/capture/7b4a2254-f1bf-4e78-8fa6-2a336ac7b526"},
    {id: 17539, link: "https://poly.cam/capture/d820d570-98d7-4c98-9449-a79b80474889"},
    {id: 16654, link: "https://poly.cam/capture/6f8892b2-9943-4d26-ade6-7fbc4264b7a1"},
    {id: 19009, link: "https://poly.cam/capture/d23f0f91-850a-450e-9ddc-b4c47f55b1e4"},
    {id: 17405, link: "https://poly.cam/capture/503cc324-57a5-449e-87cd-1857bea49810"},
    {id: 16436, link: "https://poly.cam/capture/ebed1444-a68a-4a97-8eca-c85b2e1c0935"},
    {id: 19325, link: "https://poly.cam/capture/9c92a02b-452d-402e-bb51-acd58b9f812a"},
    {id: 18383, link: "https://poly.cam/capture/3ffda269-f1b1-4fc1-b809-de16f05a9162"},
    {id: 17209, link: "https://poly.cam/capture/3a1f6f26-c349-4237-8b95-c09dab1b54d3"},
    {id: 19428, link: "https://poly.cam/capture/cff4f5d7-d34a-4358-a8b9-f6c39059749a"},
    {id: 19081, link: "https://poly.cam/capture/448dd4d4-411a-47db-98ae-e853fdf9b908"},
    {id: 19227, link: "https://poly.cam/capture/9441a62c-875f-4703-aac7-b456ac6e41e6"},
    {id: 18855, link: "https://poly.cam/capture/ccf6263c-db7f-47b1-939e-19643f5a4e48"},
    {
        id: 17980,
        link: "https://poly.cam/capture/6d89171e-0dfa-4029-a29c-db7a4d2cddd9",
        history: [{link: "https://poly.cam/capture/2b790101-676a-4f43-99d9-455a1c6fb81b"}]
    },
    {id: 13981, link: "https://poly.cam/capture/43a171f9-d5f8-43d5-a329-c656674f5eab"},
    {id: 18850, link: "https://poly.cam/capture/8dbe856e-8a49-40aa-a31c-db05427a42b9"},
    {id: 17225, link: "https://poly.cam/capture/144ff29f-f1c7-44e2-8920-86ef9908c931"},
    {id: 14742, link: "https://poly.cam/capture/0e674c92-96d0-4206-b59a-5ec4789e9908"},
    {id: 18815, link: "https://poly.cam/capture/5ab2c833-fdbd-45fe-b6fa-2718e511ba15"},
    {id: 18472, link: "https://poly.cam/capture/0260e255-4a26-4ca1-bfff-3cd50c86cdf7"},
    {id: 14503, link: "https://poly.cam/capture/840720a0-b162-4fe0-950d-6ec7f717cf6a"},
    {id: 17869, link: "https://poly.cam/capture/e725751e-707a-42a0-9e69-2afcf99b667d"},
    {id: 18392, link: "https://poly.cam/capture/b6806071-d39e-4f88-96c9-f13f1cb96872"},
    {id: 19184, link: "https://poly.cam/capture/f1447926-eb9d-413c-8ecb-c6e2e5daeb82"},
    {id: 19943, link: "https://poly.cam/capture/a32ad1f6-6850-4f3d-96e5-63dee2771f7a"},
    {id: 17434, link: "https://poly.cam/capture/85565a66-99f0-42e6-a4d5-4b450b24f2ef"},
    {id: 9673, link: "https://poly.cam/capture/5fd82ae5-c413-43d7-9f62-403055ad4a11"},
    {id: 18757, link: "https://poly.cam/capture/2735653c-4d69-487e-958d-e309505f5a98"},
    {id: 17706, link: "https://poly.cam/capture/29e7cb0c-d061-4742-8b16-5826c879ae28"},
    {id: 17635, link: "https://poly.cam/capture/5853a0bc-cd60-4d0c-bb6c-b010ecf5da89"},
    {id: 4697, link: "https://poly.cam/capture/89beee2d-da6a-4f21-ae13-459f6eadae56"},
    {id: 16951, link: "https://poly.cam/capture/a8271eca-ffee-4588-8e93-133ebfea8de8"},
    {id: 19400, link: "https://poly.cam/capture/b523e435-ee03-4929-b22b-26a81a1d612d"},
    {id: 19288, link: "https://poly.cam/capture/9221240f-4660-4774-9197-6b833f384228"},
    {id: 18759, link: "https://poly.cam/capture/bc4d63f7-d829-4b81-b56c-2f08ebb4d7dc"},
    {id: 17800, link: "https://poly.cam/capture/2e662573-a750-4341-b4fb-0a0cb0e61250"},
    {id: 17998, link: "https://poly.cam/capture/10af6221-f286-4a56-aa95-7b65968a4f97"},
    {id: 16577, link: "https://poly.cam/capture/16413cb7-d7b0-4548-a562-5273981d69b4"},
    {id: 18951, link: "https://poly.cam/capture/939d2514-e0f8-4ea0-bbe5-70b8dcb9bbb6"},
    {id: 19588, link: "https://poly.cam/capture/dfa12c76-8604-44bb-b1f9-830487a9bba8"},
    {id: 10710, link: "https://poly.cam/capture/19ec05b3-5566-4f0a-8009-f573bcf91582"},
    {id: 17596, link: "https://poly.cam/capture/64d388fc-aa46-401b-ad39-99fa24c50cac"},
    {id: 7673, link: "https://poly.cam/capture/a1ce7f10-b3fa-401f-9f1a-389e2068f3e2"},
    {id: 17784, link: "https://poly.cam/capture/26243380-8f3b-49b7-a6b6-9200a371f9b8"},
    {id: 16406, link: "https://poly.cam/capture/8019598e-90af-43b2-8451-b4e465febc46"},
    {id: 19494, link: "https://poly.cam/capture/51864b0c-bbf9-4fb9-8514-946f8d5f22c2"},
    {id: 13391, link: "https://poly.cam/capture/5dda3124-8582-4813-95ce-22a8cc8d94fe"},
    {id: 19266, link: "https://poly.cam/capture/573872bc-7b40-4816-8c63-542609a5030c"},
    {id: 16642, link: "https://poly.cam/capture/7342ed69-596a-414b-bbb9-710cced32b1e"},
    {
        id: 11695,
        link: "https://poly.cam/capture/5d178ce7-1abd-4b88-a58f-db363fa26628",
        stageLinks: [{stageId: 1098, link: "https://poly.cam/capture/84cc6ec3-26bd-48f3-bebb-2cda2cbfcf5f"}],
        history: [{link: "https://poly.cam/capture/84cc6ec3-26bd-48f3-bebb-2cda2cbfcf5f"}]
    },
    {id: 19440, link: "https://poly.cam/capture/8d017e2b-b87c-4f65-bb8f-6d0413640510"},
    {id: 17443, link: "https://poly.cam/capture/60a47f9f-cee6-4649-b5e5-04a913cf04ac"},
    {id: 18906, link: "https://poly.cam/capture/6c618856-0402-4139-b1f7-54fecb6e4e35"},
    {id: 10364, link: "https://poly.cam/capture/900a8136-0f07-45a8-ace1-af3058cebf1b"},
    {id: 17910, link: "https://poly.cam/capture/07409bf3-5b71-4332-be5c-5446cd84739a"},
    {id: 19397, link: "https://poly.cam/capture/c14e0e56-7d06-4dd2-b6be-bba9ad82b1a5"},
    {id: 19705, link: "https://poly.cam/capture/b053a517-fbcc-4499-a197-464cc4f24e0e"},
    {id: 16202, link: "https://poly.cam/capture/c053ce75-dd92-4823-82b5-70810bc824a8"},
    {id: 20094, link: "https://poly.cam/capture/c5285906-6bbe-4a6f-86d7-54aeb82b12bb"},
    {id: 17090, link: "https://poly.cam/capture/3dd78789-27e8-432a-a01c-edf9fa820b3c"},
    {id: 20011, link: "https://poly.cam/capture/1f9ba517-ab58-4696-9034-0cee8d0f58d3"},
    {id: 19751, link: "https://poly.cam/capture/b5e7e9fa-f6a7-49a1-9485-21af79f84ab3"},
    {id: 17901, link: "https://poly.cam/capture/186a3684-42cc-499a-937c-e7eec952cded"},
    {id: 18048, link: "https://poly.cam/capture/16a52cde-02ad-49e7-80c7-2b6c41c21463"},
    {id: 18508, link: "https://poly.cam/capture/27720850-3580-4772-ba00-4c6a14d430f5"},
    {id: 18341, link: "https://poly.cam/capture/fd5f9357-81cd-4bbc-9b93-4dad60c2c170"},
    {id: 17814, link: "https://poly.cam/capture/fab53046-3197-4143-8d7b-acb1fd9faace"},
    {id: 17764, link: "https://poly.cam/capture/ebd5b0e2-0543-47e8-af0d-7d6257accd9f"},
    {id: 16798, link: "https://poly.cam/capture/5a503278-4878-462b-a3be-17c8502353e5"},
    {id: 19501, link: "https://poly.cam/capture/f0532ce6-87a4-4b1e-8c33-ee241d6c6e98"},
    {id: 19250, link: "https://poly.cam/capture/cd31b0c3-af42-4ce7-84e8-6623c3a74f8c"},
    {id: 19183, link: "https://poly.cam/capture/3850dbc0-f67d-40b5-812a-ea751f1f83a7"},
    {id: 19095, link: "https://poly.cam/capture/9f8b5ef6-b4f0-4bc6-b23e-5576e3ff2646"},
    {id: 17714, link: "https://poly.cam/capture/020bc00e-275e-4ddb-be1c-d30cd452e606"},
    {id: 14816, link: "https://poly.cam/capture/c3b2e7a1-9089-45f1-88a7-26ea35eef376"},
    {id: 17685, link: "https://poly.cam/capture/31f464e8-db85-4269-b508-a88e3e90fbde"},
    {id: 16655, link: "https://poly.cam/capture/79d8557a-4ad9-44d5-9891-5f1d3dabc6ef"},
    {id: 18123, link: "https://poly.cam/capture/020b9cbf-9ad3-484c-ba0a-a1722be48273"},
    {id: 20163, link: "https://poly.cam/capture/8abf2a19-1452-49ef-aeb5-a9586038f8fc"},
    {id: 17196, link: "https://poly.cam/capture/aa740ad5-57d2-451c-95d6-54756afa2365"},
    {id: 16774, link: "https://poly.cam/capture/6648a4c2-783c-4865-85aa-d2030c613a81"},
    {id: 16207, link: "https://poly.cam/capture/f3b33777-41cc-4d18-a932-fa680c455b2b"},
    {id: 17305, link: "https://poly.cam/capture/0cf84c70-2fc8-44e1-be44-6019c450c394"},
    {id: 18621, link: "https://poly.cam/capture/5fe4faff-dcf7-4ce5-ad39-98b6f5ff3d86"},
    {id: 10122, link: "https://poly.cam/capture/73d7b498-c9f6-48bb-9ed3-e029d296329b"},
    {id: 18514, link: "https://poly.cam/capture/250efc4a-3cb2-4460-a437-2d4472afda4e"},
    {id: 17239, link: "https://poly.cam/capture/a08d421e-6e51-41a6-8e13-448617171c6b"},
    {id: 13729, link: "https://poly.cam/capture/7d7366dd-2312-4206-ac20-2d1f0fe23901"},
    {id: 20258, link: "https://poly.cam/capture/8b1b79fa-88bf-4b7d-afdb-9f4b5235ae8b"},
    {id: 13879, link: "https://poly.cam/capture/7a9da8e4-d6fe-4365-a3eb-3b393ac33369"},
    {id: 16760, link: "https://poly.cam/capture/2f55fbf5-9635-4287-8828-c439a636b475"},
    {id: 16755, link: "https://poly.cam/capture/128bddbc-d82e-425a-b2ac-22b4a2b04c51"},
    {id: 17320, link: "https://poly.cam/capture/d919a1c7-7edb-4516-9d4e-e96477404a1b"},
    {id: 16226, link: "https://poly.cam/capture/0f27f78d-3cf8-46c2-a8d4-1080cd42b04e"},
    // Kraków
    {
        id: 15916,
        link: "https://poly.cam/capture/a55eab86-c84d-4b35-ab38-1bd0da8e4d18",
        history: [{link: "https://poly.cam/capture/ba183d67-c389-496e-b4e8-e053dd0267c4"}]
    },
    {
        id: 17751,
        link: "https://poly.cam/capture/909ecb0e-9707-4daa-b5f4-e5a85d47af0c",
        history: [{link: "https://poly.cam/capture/5dd38ae5-b343-4b58-8e77-717997eac3a2"}]
    },
    {
        id: 17776,
        link: "https://poly.cam/capture/fcc58636-85bc-436e-b079-7c6b73a30ae0",
        history: [{link: "https://poly.cam/capture/9a8b1f6d-9e66-4659-a928-daf327a2814c"}]
    },
    {
        id: 17878,
        link: "https://poly.cam/capture/7bd32628-3099-4e86-a014-2c788a48a4b8",
        history: [{link: "https://poly.cam/capture/709bf5fb-52db-4552-a6bc-d9f3d218c128"}]
    },
    {
        id: 19549,
        link: "https://poly.cam/capture/9b656bca-1f01-4d62-bb97-bb00ccf5d865",
        history: [{link: "https://poly.cam/capture/506fc0c0-137a-4fd0-8cd3-d8fe45cee8e3"}]
    },
    {id: 19047, link: "https://poly.cam/capture/49da0243-d81d-42cc-a06f-26ec8db0e040"},
    {
        id: 16983,
        link: "https://poly.cam/capture/55cc6b1d-b02c-4bb4-a4a2-09abf2e6d8aa",
        history: [{link: "https://poly.cam/capture/7a699982-e85a-43cc-bcd6-050207158b28"}]
    },
    {
        id: 16851,
        link: "https://poly.cam/capture/3e8e3ac2-a9f5-4d52-984f-8cea20f1d1aa",
        history: [{link: "https://poly.cam/capture/a749a2de-3a13-48ca-9c3f-0720d3e80317"}]
    },
    {
        id: 18385,
        link: "https://poly.cam/capture/88b952d8-4b69-40b2-b571-4c3b1d4c6d9a",
        history: [{link: "https://poly.cam/capture/cc10f81e-4076-449d-9acc-5454f5e4be2a"}]
    },
    {
        id: 17289,
        link: "https://poly.cam/capture/0f0a9bc0-afe7-4740-b755-02115dfdbf61",
        history: [{link: "https://poly.cam/capture/faba676c-6454-4e48-b3a3-26e1cfcea25e"}]
    },
    {id: 18283, link: "https://poly.cam/capture/a27cbd0d-feb3-4bff-84fd-bf9539630877"},
    {id: 17493, link: "https://poly.cam/capture/c39adcff-98f5-4063-a47d-3a3457652ff0"},
    {id: 15462, link: "https://poly.cam/capture/aaa50b50-09de-4722-8b6c-18ce8089a2bc"},
    {id: 19045, link: "https://poly.cam/capture/9cc1ada3-8ae9-4cab-8168-722a704ea7e0"},
    {id: 17812, link: "https://poly.cam/capture/c227801f-3b40-437b-aff1-109124213593"},
    {id: 19800, link: "https://poly.cam/capture/7874253a-be6d-47b5-8d4d-1ca815107e7f"},
    {id: 17601, link: "https://poly.cam/capture/347ebf18-61a3-4d5a-93a8-ce6d4a6b4492"},
    {id: 18706, link: "https://poly.cam/capture/2a6ad0f3-233d-438e-9696-e8189a9e22f8"},
    {id: 17309, link: "https://poly.cam/capture/ede381c0-a4ab-4dcb-8923-ad2281eda93a"},
    {id: 12831, link: "https://poly.cam/capture/8a30ecff-e2c0-4527-91be-c46e36a7afbc"},
    {id: 18242, link: "https://poly.cam/capture/2ba25dcd-63d8-4e35-96da-30645eab0156"},
    {id: 17526, link: "https://poly.cam/capture/894766cd-ee49-4b47-9df3-d6cf7036c779"},
    {id: 17367, link: "https://poly.cam/capture/af239131-e103-44e9-bde3-a5899c0535e5"},
    {id: 20204, link: "https://poly.cam/capture/1f5e6865-5c21-4a00-beba-24f3478d8778"},
    {id: 16036, link: "https://poly.cam/capture/4484484c-deb9-4eee-9dfc-a30829ae2323"},
    {id: 14423, link: "https://poly.cam/capture/a57fc610-61df-4639-836a-50764916fa72"},
    {id: 19652, link: "https://poly.cam/capture/203d6582-ba54-4747-b0d6-cb73f6cbe942"},
    {id: 18831, link: "https://poly.cam/capture/a8d15b8a-7b8c-4ed2-a4d7-0d0d759f2763"},
    {id: 17541, link: "https://poly.cam/capture/356cb65f-c6af-4d54-b986-c7c260cac1d4"},
    {id: 14404, link: "https://poly.cam/capture/d6fec8a6-3bd1-4a69-bb45-2eec4ce0bd40"},
    {id: 17463, link: "https://poly.cam/capture/83e70faa-5224-4c94-bdf5-f0f2751a4cca"},
    {id: 19247, link: "https://poly.cam/capture/3b0c47bd-6311-4378-bcc8-8f66b1a04186"},
    {id: 17527, link: "https://poly.cam/capture/b63b7112-06b0-400c-91f7-24346f233171"},
    {id: 18821, link: "https://poly.cam/capture/95fbe5c7-a548-4bce-86f9-0f794bc70c8a"},
    {id: 15016, link: "https://poly.cam/capture/7af23b5f-1943-4ed7-b435-78721f3c7e05"},
    {id: 19540, link: "https://poly.cam/capture/eb06b062-fc73-4f9b-b9d0-f96512af711d"},
    {id: 20121, link: "https://poly.cam/capture/359ff5cc-50ca-4c45-af59-ad963f592195"},
    {id: 18742, link: "https://poly.cam/capture/bc137ca3-c7d0-4beb-b537-a6f2478eecf7"},
    {id: 19460, link: "https://poly.cam/capture/5f94a0c7-5241-472a-8cb3-9c2ade4287ff"},
    {id: 7849, link: "https://poly.cam/capture/dac57b95-0e48-40c9-a4c5-218adfaeb7d0"},
    {id: 16435, link: "https://poly.cam/capture/bfa71b09-820e-4a4e-af01-75c2c235a154"},
    {id: 19744, link: "https://poly.cam/capture/20b9a59a-1fc9-42f6-b911-82ec2d5210b3"},
    {id: 19922, link: "https://poly.cam/capture/1381624c-9f26-45cb-9855-53333e36580f"},
    {id: 19659, link: "https://poly.cam/capture/ea8dd122-7434-4a32-a121-7e93999ddb21"},
    {id: 15411, link: "https://poly.cam/capture/cd749860-02e6-4fd7-9c57-c4b988fd6b5e"},
    {id: 13081, link: "https://poly.cam/capture/0e4187a7-171f-4049-9fb2-70297a4be55e"},
    {id: 840, link: "https://poly.cam/capture/61c19e61-e592-4d60-84d1-1e33d34d1448"},
    {id: 17074, link: "https://poly.cam/capture/b631d21b-ee6a-4b96-bcde-c8355b91b3f1"},
    {id: 18882, link: "https://poly.cam/capture/56699c6d-e97c-4277-95b2-a6fd80176120"},
    {id: 16361, link: "https://poly.cam/capture/f53b56bd-6b5e-408f-8449-49acdf1e5b49"},
    {id: 18254, link: "https://poly.cam/capture/6bb4628a-ac37-4ba4-8bf9-cfc293745229"},
    {id: 19634, link: "https://poly.cam/capture/9e3c4d82-fe3f-4402-aa77-29221064cbca"},
    {id: 18957, link: "https://poly.cam/capture/6c34e502-1541-4d82-a199-6539972d6b0c"},
    {id: 18230, link: "https://poly.cam/capture/a7f08f86-4edc-456c-9e21-1d20004c0f1a"},
    {id: 19878, link: "https://poly.cam/capture/074c8f0c-cf3f-4381-9544-f7041b4e2ca2"},
    {id: 18286, link: "https://poly.cam/capture/0d8b2cc9-40e7-494a-88ce-142a8e44d420"},
    {id: 16274, link: "https://poly.cam/capture/6a2208b9-ba9e-4219-946a-f8fbc3af6c00"},
    {id: 16950, link: "https://poly.cam/capture/c4925609-43d9-4bff-a8c4-ea0dc822a2ef"},
    {id: 17498, link: "https://poly.cam/capture/b68d7639-671f-45fb-a36c-a7614da6dc44"},
    {id: 18496, link: "https://poly.cam/capture/3f6c0ab1-ec27-4bd1-9e7d-5c3849246ee0"},
    // Poznań
    {id: 18826, link: "https://poly.cam/capture/58c42f89-44d3-4343-98fb-4f1e0dc4dd1c"},
    {id: 16944, link: "https://poly.cam/capture/11baa27b-8662-4616-8be1-c77dfa3d6b07"},
    {id: 16937, link: "https://poly.cam/capture/a6bc6204-e39d-43a1-9104-2b28a5157c9e"},
    {id: 19463, link: "https://poly.cam/capture/fbfaf9ba-a5d0-4d3b-bfed-75e84da1f21c"},
    {id: 18497, link: "https://poly.cam/capture/cedc2a02-5f0b-4eaa-93d1-02c994f113d4"},
    {id: 19010, link: "https://poly.cam/capture/b48dedfb-8249-41b9-a923-a806f79298f1"},
    {id: 17247, link: "https://poly.cam/capture/d41ebd34-3261-407b-90a2-62ffe60ae9b1"},
    {id: 15914, link: "https://poly.cam/capture/b9689bd6-39fa-4b80-a084-ccf6909a7c2c"},
    {id: 10708, link: "https://poly.cam/capture/d8ecf900-5f7d-44e1-b4de-3637df568c07"},
    {
        id: 15148,
        link: "https://poly.cam/capture/6d186bc3-179b-4e74-ae19-3c666d082e84",
        stageLinks: [{stageId: 802, link: "https://poly.cam/capture/0c5005bd-c104-403f-9605-5718fbaad6ed"}]
    },
    {id: 16809, link: "https://poly.cam/capture/6142af90-bb41-4fab-a851-b3c6a552f3e8"},
    {id: 16228, link: "https://poly.cam/capture/9f9118ea-88b8-4914-aade-b59bbf5d70f0"},
    {id: 18139, link: "https://poly.cam/capture/95710ef9-9462-46f9-bbb9-f47210bc4744"},
    {id: 17044, link: "https://poly.cam/capture/1bcb47e6-8a15-4d71-91d1-4916b7fdeff8"},
    {id: 17921, link: "https://poly.cam/capture/38171199-a8af-459c-98c9-02407084a135"},
    {id: 19459, link: "https://poly.cam/capture/f26958d2-e85f-4eec-b860-1f433f57d16c"},
    {id: 14159, link: "https://poly.cam/capture/1c71506e-148b-4762-b5e9-3e272346c898"},
    {id: 19561, link: "https://poly.cam/capture/a45b381f-9b80-45f4-b5d8-f4f5843a825e"},
    {id: 17078, link: "https://poly.cam/capture/14e9bd83-5cfd-4282-b119-fbfdabcfa96d"},
    {id: 12991, link: "https://poly.cam/capture/5c947d52-9610-4d16-8b0b-b270f9a2afe1"},
    {id: 18833, link: "https://poly.cam/capture/ba0f0bc3-f8f1-4521-90df-0caefd50b62c"},
    {id: 14425, link: "https://poly.cam/capture/556e1a28-7ea3-485a-acfb-a7e2128697ee"},
    {id: 4930, link: "https://poly.cam/capture/66cf8255-adc5-465e-84a0-080a58aedfe8"},
    {id: 17474, link: "https://poly.cam/capture/4a344fa7-7c74-42e8-94b8-083e48fd8837"},
    {id: 16668, link: "https://poly.cam/capture/26301cc2-2769-4ac1-837c-65ec57eba891"},
    {id: 19058, link: "https://poly.cam/capture/8e566464-9333-4ad2-8352-ff768d1a4e6d"},
    {id: 17845, link: "https://poly.cam/capture/f99ab6ab-643e-4bd1-b158-0c5f9df08434"},
    {id: 16365, link: "https://poly.cam/capture/8b6a3679-a0e7-4d21-9341-469759c76b68"},
    {id: 18256, link: "https://poly.cam/capture/bef78bf4-a10e-4183-901f-616eabcd439b"},
    {id: 16294, link: "https://poly.cam/capture/29be0ea4-e30f-4068-bb4a-d1b469cbd93a"},
    {id: 17065, link: "https://poly.cam/capture/bf97de04-ffb3-42b2-8097-560450dd8289"},
    {id: 17672, link: "https://poly.cam/capture/610bb611-64be-44ee-b4ad-4f051c964eab"},
    {id: 14111, link: "https://poly.cam/capture/96eaf2e5-f847-4612-9456-fc7abe82f50b"},
    {id: 17291, link: "https://poly.cam/capture/47c57fd7-bd68-4dc8-a3b6-dc6a1e515b25"},
    {id: 16538, link: "https://poly.cam/capture/ad97f90b-a90d-40e2-9c55-971a411271fc"},
    {id: 20059, link: "https://poly.cam/capture/e7b01111-edf6-4fbc-bad5-28e711302d1f"},
    {id: 15757, link: "https://poly.cam/capture/65fcef86-641c-4223-baae-54c1c224751c"},
    {id: 18998, link: "https://poly.cam/capture/5dd42cd3-2537-4501-ad2e-1b2ba4d311a8"},
    {id: 16194, link: "https://poly.cam/capture/5dd42cd3-2537-4501-ad2e-1b2ba4d311a8"},
    {id: 19140, link: "https://poly.cam/capture/e297deb8-bd6e-4743-a650-945ea7f6d65e"},
    {id: 16482, link: "https://poly.cam/capture/80cc7370-0d85-41d6-9667-99754d310669"},
    {id: 18105, link: "https://poly.cam/capture/a25ff40b-61d6-4032-a922-3733b602b436"},
    {id: 17794, link: "https://poly.cam/capture/6f26f687-01ae-4cb8-a623-2286f6d4ff67"},
    {id: 16548, link: "https://poly.cam/capture/b3f04d4e-c7b5-42f1-b188-292e6e2d7a59"},
    // Wrocław
    {id: 12266, link: "https://poly.cam/capture/ca66e111-0686-47ff-9b39-3c0a3d4af454"},
    {id: 17244, link: "https://poly.cam/capture/86363acf-d053-40a9-8d86-fb8040688ce4"},
    {id: 14657, link: "https://poly.cam/capture/3c6625e7-2cb2-4391-81ab-4b10e6b9be12"},
    {id: 19217, link: "https://poly.cam/capture/ba841fd1-c421-4653-b78a-df7948039d1a"},
    {id: 17908, link: "https://poly.cam/capture/7f5a3113-5350-478a-b859-d2924371d1fe"},
    {id: 19499, link: "https://poly.cam/capture/a5147257-91b2-4584-b9eb-cb21cce05010"},
    {id: 16304, link: "https://poly.cam/capture/a453560d-ace3-4cbd-ae78-9c9409918d2e"},
    {id: 19863, link: "https://poly.cam/capture/e3f1e41f-f9ab-4363-99b7-be6692b055ec"},
    {id: 19328, link: "https://poly.cam/capture/00d45414-65e1-4787-ad39-1213148bc13f"},
    {id: 18854, link: "https://poly.cam/capture/95accf83-f6d9-4ac9-a890-4ab1d349598c"},
    {id: 18958, link: "https://poly.cam/capture/6394128f-37bd-485f-bf76-056e417fca9d"},
    {id: 16029, link: "https://poly.cam/capture/3158388a-e9ff-44a7-b16f-b85f8ad0b77c"},
    {id: 15887, link: "https://poly.cam/capture/a51ff85c-df0d-4fb6-a140-324489135f30"},
    {id: 3947, link: "https://poly.cam/capture/60d5c3ec-eaa8-4d7b-8c4d-2fdaeef2ad62"},
    {id: 17655, link: "https://poly.cam/capture/07e918b8-7d6e-4a7b-8e8a-b8b6928b3227"},
    {id: 16695, link: "https://poly.cam/capture/601f2087-eb7a-46c3-81c4-c9d345d046f9"},
    {id: 18276, link: "https://poly.cam/capture/0349d7b9-719a-4993-aa61-3fd71b73f507"},
    {id: 16793, link: "https://poly.cam/capture/6584113b-d768-45b9-832c-0f26bb2c15d2"},
    {id: 16704, link: "https://poly.cam/capture/b4f14cb9-9a7b-4dc2-ab42-a5fc73fbd524"},
    {id: 17170, link: "https://poly.cam/capture/6fc864c2-6e4f-46aa-907f-393f3308fc92"},
    {id: 10296, link: "https://poly.cam/capture/6bb7543f-0c25-43da-ae6a-9f5d55ef59e8"},
    {id: 19845, link: "https://poly.cam/capture/209ddc24-66c2-4b2c-bfc5-5b91e76a7b8b"},
    {id: 17625, link: "https://poly.cam/capture/aebc6dc3-252f-4168-a79b-ab8ba0443b25"},
    {id: 16092, link: "https://poly.cam/capture/23383dc2-2452-4609-9540-fbd8ff94e793"},
    {id: 17168, link: "https://poly.cam/capture/448b713a-9db9-4098-9499-54936e2e3d01"},
    {id: 18956, link: "https://poly.cam/capture/34cd5b4a-63d7-4cac-861a-f7b27ee9dfea"},
    {id: 16972, link: "https://poly.cam/capture/4395d714-a81a-4d6f-820d-d83908583ece"},
    {id: 19973, link: "https://poly.cam/capture/b31a8a53-dc44-44ee-9fb3-60f36616ed7a"},
    {id: 14552, link: "https://poly.cam/capture/d0eb1f69-fc31-43dc-8823-4a2fa0d90d17"},
    {id: 19975, link: "https://poly.cam/capture/e871f047-3e89-420e-98f8-a0750ba6cefe"},
    {id: 15924, link: "https://poly.cam/capture/50c98510-2005-452a-8e1a-e4b74564d6c2"},
    {id: 19069, link: "https://poly.cam/capture/60c55634-1516-41e2-8a8f-85339fcf05e8"},
    {id: 12652, link: "https://poly.cam/capture/4ad434ef-30d9-47d7-bf36-00584ec8841a"},
    {id: 19644, link: "https://poly.cam/capture/d9d9491a-d4d1-4916-a4cc-8379fd0a3791"},
    {id: 19664, link: "https://poly.cam/capture/c3c75acb-957c-4b12-82ed-8b2cd5730af2"},
    {id: 16407, link: "https://poly.cam/capture/841dca1b-7651-4f29-89bd-f063219de9ef"},
    {id: 18345, link: "https://poly.cam/capture/c136034c-92be-4d6d-8daa-ea6227b8d244"},
    {id: 19002, link: "https://poly.cam/capture/38874799-f136-4aae-9e1a-d0738fad17aa"},
    {id: 17793, link: "https://poly.cam/capture/145770d9-5101-4cde-a2c1-7eeb66e4e852"},
    {id: 17752, link: "https://poly.cam/capture/f6a756e3-943c-4e80-899f-a453e83cbdb1"},
    {id: 16348, link: "https://poly.cam/capture/5a5e6a93-607f-4c6f-978e-8ab628336e31"},
    {id: 19044, link: "https://poly.cam/capture/167c264a-c677-443f-8b3c-81a7bb961d0e"},
    {id: 17123, link: "https://poly.cam/capture/56c12ea2-9db6-4fd1-ad14-4081541975a4"},
    {id: 15328, link: "https://poly.cam/capture/e478efeb-5776-4a78-9e79-14d78ff1b230"},
    {id: 19514, link: "https://poly.cam/capture/24f6cc21-f6bc-43a2-8f69-a795988c7652"},
    {id: 16681, link: "https://poly.cam/capture/866de97f-add1-444c-bc8b-0a374977f118"},
    {id: 15594, link: "https://poly.cam/capture/2b17c352-805e-47fd-91f0-5ffd49524c68"},
    //Trójmiasto
    {id: 19681, link: "https://poly.cam/capture/2b7a7faf-9889-4fe7-80e5-0f513dbdb026"},
    {id: 19646, link: "https://poly.cam/capture/e26c7a1d-76d5-4ad5-b82f-a92fb561be27"},
    {id: 19437, link: "https://poly.cam/capture/101fab69-b39d-440d-a02b-9b64f1bd3f1a"},
    {id: 17603, link: "https://poly.cam/capture/cb3a5b38-a69a-4391-8746-9cd1e29427ce"},
    {id: 14700, link: "https://poly.cam/capture/0205add9-83d0-4e33-a711-88a70a198d2e"},
    {id: 19156, link: "https://poly.cam/capture/e4a22a6c-1831-425a-82ef-ed4ee997aa37"},
    {id: 19143, link: "https://poly.cam/capture/3e188151-543c-4b32-85c0-d81e498e10b5"},
    {id: 9455, link: "https://poly.cam/capture/fbc7fec9-b786-4fce-9501-13159dca182e"},
    {id: 19020, link: "https://poly.cam/capture/45eea165-8b28-4023-abdf-6d8fb766e8a6"},
    {id: 18778, link: "https://poly.cam/capture/7c0f4de1-9b92-4f88-8133-9d53ef0c32dc"},
    {id: 18617, link: "https://poly.cam/capture/4a65b354-a6c6-451a-96e0-795fa957c531"},
    {id: 18289, link: "https://poly.cam/capture/9bf384c4-970c-4169-bd7a-8174e20645f6"},
    {id: 16686, link: "https://poly.cam/capture/264075a6-e04e-4718-96d1-10d0534aac7c"},
    {id: 18137, link: "https://poly.cam/capture/4731bc12-92c3-4406-a067-4ef739a68287"},
    {id: 14542, link: "https://poly.cam/capture/88915f24-17df-4743-8af6-bc533172c035"},
    {id: 18047, link: "https://poly.cam/capture/bdd72af5-e458-4dd6-bad4-8d38485977d7"},
    {id: 13149, link: "https://poly.cam/capture/ef3c7138-91df-4048-be37-f53c424e1438"},
    {id: 17826, link: "https://poly.cam/capture/c191b186-faa5-4e6b-9594-9d473eea3508"},
    {id: 17750, link: "https://poly.cam/capture/3cf94084-85be-40ca-b44f-6f1fbe27830d"},
    {id: 17675, link: "https://poly.cam/capture/5ece34f1-bf14-44c1-a8e0-d83669bcfc55"},
    {id: 17421, link: "https://poly.cam/capture/02f4fa62-d132-492e-803a-d045116fc691"},
    {id: 17213, link: "https://poly.cam/capture/889d4b21-e2fe-4fb8-b6f1-d86ae38bae00"},
    {id: 16575, link: "https://poly.cam/capture/a8f9a9f6-4fd9-421e-9728-8fcac0fb04f0"},
    {id: 16528, link: "https://poly.cam/capture/f372dda1-44eb-4840-b627-8465ca92fd14"},
    {id: 15816, link: "https://poly.cam/capture/cdfb6a0e-33cc-4079-94ed-692026a55482"},
    {id: 15379, link: "https://poly.cam/capture/1f5eb14f-071d-4dec-9242-dfff536a089f"},
    {id: 14738, link: "https://poly.cam/capture/9062ef3d-a8a5-4805-bb87-1c57919ccc8f"},
    {
        id: 15907,
        link: "https://poly.cam/capture/8395af90-4951-43f8-93b5-48f244443bb9",
        stageLinks: [{stageId: 1538, link: "https://poly.cam/capture/8a8104f9-ddae-487f-9175-18a63f3a2b96"}],
        history: [{link: "https://poly.cam/capture/8a8104f9-ddae-487f-9175-18a63f3a2b96"}]
    },
    {id: 19357, link: "https://poly.cam/capture/a402c7ac-a751-4415-923e-b0dca68798fe"},
    {id: 18796, link: "https://poly.cam/capture/8004ebc8-1bc3-4479-b7eb-cbc9e4dd7518"},
    {id: 16595, link: "https://poly.cam/capture/6f2e3a69-b876-4f75-bfd8-f06b75ebe39d"},
    {id: 15651, link: "https://poly.cam/capture/1dbe68d1-db95-4214-9197-3f695302bb37"},
    {id: 19608, link: "https://poly.cam/capture/7593cc48-8342-489f-a435-9e661a159925"},
    {id: 20055, link: "https://poly.cam/capture/a2db3177-9f1f-46da-9846-b7e228f44622"},
    {id: 14588, link: "https://poly.cam/capture/12bfcf52-5517-46d8-8513-fc03913f174b"},
    {id: 17678, link: "https://poly.cam/capture/0c0607ad-4387-450b-927a-2fedf4cb102f"},
    {id: 10409, link: "https://poly.cam/capture/d65c905a-0f62-4685-b321-f86e11536aa8"},
    {id: 15119, link: "https://poly.cam/capture/d58316fd-98f1-4126-8801-611745f686bf"},
    {id: 17824, link: "https://poly.cam/capture/c552661f-65db-4f04-8fd2-c45f7b259240"},
    {id: 18267, link: "https://poly.cam/capture/4a688908-f7ec-4213-b1e5-592de13bb161"},
    {id: 15180, link: "https://poly.cam/capture/49f79088-fa58-442c-b94c-909a1d28279d"},
    {id: 19187, link: "https://poly.cam/capture/4dfa0a70-3944-4d9d-a874-6aae5e356ba3"},
    {id: 16984, link: "https://poly.cam/capture/6db17809-95fe-4f83-85f4-698b131d8549"},
    {id: 20017, link: "https://poly.cam/capture/86217e8b-8151-48e6-813c-3070bce7714d"},
    {id: 19393, link: "https://poly.cam/capture/fc85ea0d-cf4c-4d58-91bc-45cecbc89fdb"},
    {id: 16949, link: "https://poly.cam/capture/0f0b881a-e985-42b6-b256-890d3959f625"}
];
